import Navbar from './navBar'
import Sidebar from './sideBar'
import AppMain from './appMain'
import AppFooter from './appFooter'


export default {
    Navbar,
    Sidebar,
    AppMain,
    AppFooter
}